import PropTypes from 'prop-types';
import { Transition } from '@headlessui/react';
import cx from 'classnames';
import ArrowDown from '../../assets/animations/ArrowDown';

const Accordion = ({
    title,
    toggleAccordion,
    active,
    children,
    filled,
    withBorder,
    childrenClassName,
}) => {
    const accordionToggle = cx(
        'w-full flex flex-row justify-between items-center font-body p-2 cursor-pointer transition duration-300 ease-in',
        active || !withBorder ? 'border-b-0' : 'border-b border-ui-gray-900'
    );

    const accordionActive = withBorder ? 'border-b border-ui-gray-900' : '';

    return (
        <div className={cx('h-max w-full', active && accordionActive)}>
            <div
                className={cx(accordionToggle, filled && 'bg-black text-white')}
                onClick={() => toggleAccordion()}
            >
                <h3 itemProp='name' className='mb-0 text-h3'>
                    {title}
                </h3>
                <span>
                    <ArrowDown open={active} className={filled ? 'h-5 w-5 text-ui-white' : null} />
                </span>
            </div>
            <Transition
                show={active}
                enter='transition ease-out duration-200'
                enterFrom='transform opacity-0 scale-95'
                enterTo='transform opacity-100 scale-100'
                leave='transition ease-in duration-150'
                leaveFrom='transform opacity-100 scale-100'
                leaveTo='transform opacity-0 scale-95'
            >
                {active && (
                    <div
                        className={cx(
                            'p-2',
                            childrenClassName,
                            filled ? 'bg-brand-primary-100' : ''
                        )}
                    >
                        {children}
                    </div>
                )}
            </Transition>
        </div>
    );
};

Accordion.defaultProps = { filled: false };

Accordion.propTypes = {
    title: PropTypes.string.isRequired,
    toggleAccordion: PropTypes.func.isRequired,
    active: PropTypes.bool.isRequired,
    children: PropTypes.node,
    filled: PropTypes.bool,
    withBorder: PropTypes.bool,
    childrenClassName: PropTypes.string,
};

export default Accordion;
